'use client';

import { Field } from '.';
import { ComponentPropsWithoutRef, ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Icon } from '@/shared/ui/icon';
import './field.scss';

type Props = ComponentPropsWithoutRef<typeof Field> & Omit<ComponentPropsWithRef<'input'>, 'type'>;
export const DateField = ({
    id,
    name,
    placeholder = ' ',
    label,
    state,
    disabled,
    className,
    labelProps,
    legendProps,
    fieldsetProps,
    ...props
}: Props) => {
    const fieldId = label && !id ? name : id;

    return (
        <Field
            id={fieldId}
            disabled={disabled}
            label={label}
            state={state}
            labelProps={labelProps}
            legendProps={legendProps}
            fieldsetProps={fieldsetProps}
            right={<Icon name="calendar" className="field__icon-btn" />}
        >
            <input
                id={label ? fieldId : undefined}
                type="date"
                placeholder={placeholder}
                className={cn('field__input', 'field__input--date', className)}
                aria-invalid={state === 'error'}
                disabled={disabled}
                {...props}
            />
        </Field>
    );
};
